import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'nl-be',
  Pagination: {
    items_per_page: '/ pagina',
    jump_to: 'Ga naar',
    jump_to_confirm: 'bevestigen',
    page: '',
    prev_page: 'Vorige pagina',
    next_page: 'Volgende pagina',
    prev_5: 'Vorige 5 pagina\'s',
    next_5: 'Volgende 5 pagina\'s',
    prev_3: 'Vorige 3 pagina\'s',
    next_3: 'Volgende 3 pagina\'s',
  },
  DatePicker: {
    lang: {
      monthPlaceholder: 'Selecteer maand',
      placeholder: 'Selecteer datum',
      quarterPlaceholder: 'Selecteer kwartaal',
      rangeMonthPlaceholder: [
        'Begin maand',
        'Eind maand',
      ],
      rangePlaceholder: [
        'Begin datum',
        'Eind datum',
      ],
      rangeWeekPlaceholder: [
        'Begin week',
        'Eind week',
      ],
      rangeYearPlaceholder: [
        'Begin jaar',
        'Eind jaar',
      ],
      weekPlaceholder: 'Selecteer week',
      yearPlaceholder: 'Selecteer jaar',
      locale: 'nl_BE',
      today: 'Vandaag',
      now: 'Nu',
      backToToday: 'Terug naar vandaag',
      ok: 'Ok',
      clear: 'Reset',
      month: 'Maand',
      year: 'Jaar',
      timeSelect: 'Selecteer tijd',
      dateSelect: 'Selecteer datum',
      monthSelect: 'Kies een maand',
      yearSelect: 'Kies een jaar',
      decadeSelect: 'Kies een decennium',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorige maand (PageUp)',
      nextMonth: 'Volgende maand (PageDown)',
      previousYear: 'Vorig jaar (Control + left)',
      nextYear: 'Volgend jaar (Control + right)',
      previousDecade: 'Vorig decennium',
      nextDecade: 'Volgend decennium',
      previousCentury: 'Vorige eeuw',
      nextCentury: 'Volgende eeuw',
    },
    timePickerLocale: {
      placeholder: 'Selecteer tijd',
      rangePlaceholder: [
        'Start tijd',
        'Eind tijd',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Selecteer tijd',
    rangePlaceholder: [
      'Start tijd',
      'Eind tijd',
    ],
  },
  Calendar: {
    lang: {
      monthPlaceholder: 'Selecteer maand',
      placeholder: 'Selecteer datum',
      quarterPlaceholder: 'Selecteer kwartaal',
      rangeMonthPlaceholder: [
        'Begin maand',
        'Eind maand',
      ],
      rangePlaceholder: [
        'Begin datum',
        'Eind datum',
      ],
      rangeWeekPlaceholder: [
        'Begin week',
        'Eind week',
      ],
      rangeYearPlaceholder: [
        'Begin jaar',
        'Eind jaar',
      ],
      weekPlaceholder: 'Selecteer week',
      yearPlaceholder: 'Selecteer jaar',
      locale: 'nl_BE',
      today: 'Vandaag',
      now: 'Nu',
      backToToday: 'Terug naar vandaag',
      ok: 'Ok',
      clear: 'Reset',
      month: 'Maand',
      year: 'Jaar',
      timeSelect: 'Selecteer tijd',
      dateSelect: 'Selecteer datum',
      monthSelect: 'Kies een maand',
      yearSelect: 'Kies een jaar',
      decadeSelect: 'Kies een decennium',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorige maand (PageUp)',
      nextMonth: 'Volgende maand (PageDown)',
      previousYear: 'Vorig jaar (Control + left)',
      nextYear: 'Volgend jaar (Control + right)',
      previousDecade: 'Vorig decennium',
      nextDecade: 'Volgend decennium',
      previousCentury: 'Vorige eeuw',
      nextCentury: 'Volgende eeuw',
    },
    timePickerLocale: {
      placeholder: 'Selecteer tijd',
      rangePlaceholder: [
        'Start tijd',
        'Eind tijd',
      ],
    },
  },
  global: {
    placeholder: 'Maak een selectie',
  },
  Table: {
    cancelSort: 'Klik om sortering te annuleren',
    collapse: 'Rij inklappen',
    emptyText: 'Geen data',
    expand: 'Rij uitklappen',
    filterConfirm: 'OK',
    filterEmptyText: 'Geen filters',
    filterReset: 'Reset',
    filterTitle: 'Filteren',
    selectAll: 'Selecteer huidige pagina',
    selectInvert: 'Keer volgorde om',
    selectNone: 'Maak selectie leeg',
    selectionAll: 'Selecteer alle data',
    sortTitle: 'Sorteren',
    triggerAsc: 'Klik om oplopend te sorteren',
    triggerDesc: 'Klik om aflopend te sorteren',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annuleer',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annuleer',
  },
  Transfer: {
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Verwijder',
    removeAll: 'Verwijder alles',
    removeCurrent: 'Verwijder huidige pagina',
    searchPlaceholder: 'Zoek hier',
    selectAll: 'Selecteer alles',
    selectCurrent: 'Selecteer huidige pagina',
    selectInvert: 'Huidige pagina omkeren',
    titles: [
      '',
      '',
    ],
  },
  Upload: {
    downloadFile: 'Bestand downloaden',
    previewFile: 'Preview file',
    removeFile: 'Verwijder bestand',
    uploadError: 'Fout tijdens uploaden',
    uploading: 'Uploaden...',
  },
  Empty: {
    description: 'Geen gegevens',
  },
  Icon: {
    icon: 'icoon',
  },
  Text: {
    edit: 'Bewerken',
    copy: 'kopiëren',
    copied: 'Gekopieerd',
    expand: 'Uitklappen',
  },
  PageHeader: {
    back: 'Terug',
  },
  Form: {
    optional: '(optioneel)',
    defaultValidateMessages: {
      default: 'Validatiefout voor ${label}',
      required: 'Gelieve ${label} in te vullen',
      enum: '${label} moet één van [${enum}] zijn',
      whitespace: '${label} mag geen blanco teken zijn',
      date: {
        format: '${label} heeft een ongeldig formaat',
        parse: '${label} kan niet naar een datum omgezet worden',
        invalid: '${label} is een ongeldige datum',
      },
      types: {
        string: '${label} is geen geldige ${type}',
        method: '${label} is geen geldige ${type}',
        array: '${label} is geen geldige ${type}',
        object: '${label} is geen geldige ${type}',
        number: '${label} is geen geldige ${type}',
        date: '${label} is geen geldige ${type}',
        boolean: '${label} is geen geldige ${type}',
        integer: '${label} is geen geldige ${type}',
        float: '${label} is geen geldige ${type}',
        regexp: '${label} is geen geldige ${type}',
        email: '${label} is geen geldige ${type}',
        url: '${label} is geen geldige ${type}',
        hex: '${label} is geen geldige ${type}',
      },
      string: {
        len: '${label} moet ${len} karakters lang zijn',
        min: '${label} moet minimaal ${min} karakters lang zijn',
        max: '${label} mag maximaal ${max} karakters lang zijn',
        range: '${label} moet tussen ${min}-${max} karakters lang zijn',
      },
      number: {
        len: '${label} moet gelijk zijn aan ${len}',
        min: '${label} moet minimaal ${min} zijn',
        max: '${label} mag maximaal ${max} zijn',
        range: '${label} moet tussen ${min}-${max} liggen',
      },
      array: {
        len: 'Moeten ${len} ${label} zijn',
        min: 'Minimaal ${min} ${label}',
        max: 'maximaal ${max} ${label}',
        range: 'Het aantal ${label} moet tussen ${min}-${max} liggen',
      },
      pattern: {
        mismatch: '${label} komt niet overeen met het patroon ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Voorbeeld',
  },
};

export default localeValues;
